import { flowRight } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { lifecycle, withProps } from 'recompose';
import { formValues } from 'redux-form';
import { employmentStatuses, socioProfessionalCategories } from 'common/choices';
import addPrefix from 'common/utils/addPrefix';
import { IntegerField, TextField, ChoiceField } from '../../form/field';
import { GridLayout } from '../../form/layout';
import isRequiredField from '../../../../../common/src/utils/isRequiredField';
import { getRequiredFieldActivationDate } from '../../../actions';

const TaxCommon = ({
    createdAt, employmentStatus, partnerEmploymentStatus,
    partner, required, requiredFieldActivationDateReducer,
}) => {
    const getIdentifier = addPrefix('partner')(partner);
    const isRequired = isRequiredField(createdAt, requiredFieldActivationDateReducer, 'employmentStatus');

    return (
        <div className="rip-civil-state">
            <GridLayout className="triple condensed wide-inputs gray-box">
                <TextField
                    title={`Profession${partner ? ' du conjoint' : ''}`}
                    placeholder="Profession"
                    required={required}
                    name={getIdentifier('job')}
                    nombreCaractereMax={32}
                />
                <IntegerField
                    title={`Âge de début d'activité${partner ? ' du conjoint' : ''}`}
                    name={getIdentifier('startingActivityAge')}
                />
                <IntegerField
                    title={`Ancienneté${partner ? ' du conjoint' : ''} (nombre d'années)`}
                    info="Ancienneté dans ce métier"
                    placeholder="Nombre d'années"
                    name={getIdentifier('seniority')}
                    min={0}
                    step={1}
                />
                <ChoiceField
                    choices={employmentStatuses}
                    title={`${partner ? '' : 'Votre '}Statut professionnel${partner ? ' du conjoint' : ''}`}
                    name={getIdentifier('employmentStatus')}
                    required={isRequired && required}
                />
                {((!partner && employmentStatus) || (partner && partnerEmploymentStatus)) ? (
                    <ChoiceField
                        choices={socioProfessionalCategories[partner ? partnerEmploymentStatus : employmentStatus]}
                        title={`Catégorie Socio-Professionnelle${partner ? ' du conjoint' : ''}`}
                        name={getIdentifier('socioProfessionalCategory')}
                        required={isRequired && required}
                    />
                ) : null}
            </GridLayout>
        </div>
    );
};

TaxCommon.propTypes = {
    createdAt: PropTypes.string,
    partner: PropTypes.bool,
    employmentStatus: PropTypes.string,
    partnerEmploymentStatus: PropTypes.string,
    required: PropTypes.bool.isRequired,
    requiredFieldActivationDateReducer: PropTypes.shape({}),
};

TaxCommon.defaultProps = {
    partner: false,
};

export default flowRight([
    formValues({
        employmentStatus: 'employmentStatus',
        partnerEmploymentStatus: 'partnerEmploymentStatus',
        required: 'dualRip',
    }),
    withProps(({ required = false, cohabitation = false }) => ({
        required: cohabitation ? required : true,
    })),
    connect(({ requiredFieldActivationDateReducer }) => ({
        requiredFieldActivationDateReducer,
    }), { getRequiredFieldActivationDate }), lifecycle({
        componentDidMount() {
            this.props.getRequiredFieldActivationDate('employmentStatus');
        },
    }),
])(TaxCommon);
